import { DatePipe } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import {
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {
  HANDOVER_EMITTER,
  HANDOVER_REASON_NAME_HOAC,
  HANDOVER_RECEIVER,
  HANDOVER_SEND_OPERATIONS_PERMISSION_DENIED,
  HANDOVER_SEND_VALIDATION_TYPE_HO1,
  HANDOVER_SEND_VALIDATION_TYPE_HO2,
  HANDOVER_SEND_VALIDATION_TYPE_HO4_PULLING,
  HANDOVER_SEND_VALIDATION_TYPE_HO4_WORKOVER,
  HANDOVER_SEND_VALIDATION_TYPE_HO5,
  HANDOVER_SEND_VALIDATION_TYPE_HOG,
  HANDOVER_STATUSES_DISPLAY_FOOTER,
  HANDOVER_STATUS_ACCEPTED,
  HANDOVER_STATUS_CANCELED,
  HANDOVER_STATUS_CREATED,
  HANDOVER_STATUS_REJECTED,
  HANDOVER_STATUS_TAKEN,
  HANDOVER_STATUS_TAKE_PENDING,
  HANDOVER_TYPE_AREA_REASON_14_CWO_TO_OPE_ID,
  HANDOVER_TYPE_AREA_REASON_3_OPE_TO_CWO_ID,
  HANDOVER_TYPE_AREA_REASON_3_OPE_TO_PUL_ID,
  HANDOVER_TYPE_AREA_REASON_4_CWO_TO_OPE_ID,
  HANDOVER_TYPE_HLOC0_ID,
  HANDOVER_TYPE_HLOC_ID,
  HANDOVER_TYPE_HO1_ID,
  HANDOVER_TYPE_HO1_LOC_ID,
  HANDOVER_TYPE_HO2_ID,
  HANDOVER_TYPE_HO2_LOC_ID,
  HANDOVER_TYPE_HO3_ID,
  HANDOVER_TYPE_HO4_ID,
  HANDOVER_TYPE_HO4_LOC_ID,
  HANDOVER_TYPE_HO5_ID,
  HANDOVER_TYPE_HO5_LOC_ID,
  HANDOVER_TYPE_HOAC_ID,
  HANDOVER_TYPE_HOEC_ID,
  HANDOVER_TYPE_HOG_ID,
  HANDOVER_TYPE_HOG_LOC_ID,
  OPERATIONAL_AREA_COMPLETION_ID,
  OPERATIONAL_AREA_OPERATIONS_ID,
  OPERATIONAL_AREA_PULLING_ID,
  PAE_SUPPORT_EMAIL,
  PERMISSION_CANCEL_HO,
  PERMISSION_CANCEL_REJECTED_HO,
  PERMISSION_ENGINEERING_COMPLETION,
  PERMISSION_SEND_HO,
  SUCCESS_TIME_MESSAGE,
  SUCCESS_WARNING_TIME_MESSAGE,
} from 'src/app/handover-constants';
import {
  Handover,
  HandoverValidReceiversCount,
} from 'src/app/interfaces/handover';
import { HandoverRelation } from 'src/app/interfaces/handover-relation';
import { SectionsCompletion } from 'src/app/interfaces/section-completion';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverReportService } from 'src/app/services/handover-report.service';
import { HandoverService } from 'src/app/services/handover.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UserService } from 'src/app/services/user.service';
import { HandoverDetailFooterEmitterComponent } from '../handover-detail-footer-emitter/handover-detail-footer-emitter.component';
import { HandoverDetailFooterEmittersComponent } from '../handover-detail-footer-emitters/handover-detail-footer-emitters.component';
import { HoSendMessages } from './handover-detail-messages';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-handover-detail',
  templateUrl: './handover-detail.component.html',
  styleUrls: ['./handover-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HandoverDetailComponent implements OnInit {
  handover!: Handover;
  wellDataIsOpen = false;
  displayFooter = false;
  drawerIsOpened = false;
  displaySchematicComponent = false;
  displaySectionCommentComponent = false;
  readOnlyContent = false;
  toBack = '';
  whatAmI = '';
  iAmEmitter = false;
  iAmReceiver = false;
  buttonSendHoDisabled = false;
  havePermissionSend = false;
  havePermissionCancel = false;
  iAmTheSenderUser = false;
  hoActive = false;
  displayFooterEmitter = false;
  displayFooterReceiver = false;
  displayFooterView = false;
  isLoading = false;
  isValidated = false; // Stores wheter the sections completion validation as been performed or not.
  sectionsCompletion: SectionsCompletion | undefined;
  saveButtonToolTip = '';
  owRulesValidation = false;
  hasSectionsComments = false;
  currentSectionHasPendingChanges = false;
  footerHasPendingChanges = false;
  buttonSendPushed = false;
  readOnlyContentHoecHoac = false;
  readOnlyContentHoec = false;
  reasonName: string | undefined;
  isEngineerUser = false;
  isHo3 = false;
  isHo5 = false;
  isAcceptedHo = false;
  ho2 = HANDOVER_TYPE_HO2_ID;
  ho3 = HANDOVER_TYPE_HO3_ID;
  ho4 = HANDOVER_TYPE_HO4_ID;
  ho5 = HANDOVER_TYPE_HO5_ID;
  hloc0 = HANDOVER_TYPE_HLOC0_ID;
  hloc = HANDOVER_TYPE_HLOC_ID;
  ho1 = HANDOVER_TYPE_HO1_ID;
  hog = HANDOVER_TYPE_HOG_ID;
  hoec = HANDOVER_TYPE_HOEC_ID;
  hoac = HANDOVER_TYPE_HOAC_ID;
  ho2loc = HANDOVER_TYPE_HO2_LOC_ID;
  ho1loc = HANDOVER_TYPE_HO1_LOC_ID;
  hogloc = HANDOVER_TYPE_HOG_LOC_ID;
  ho4Cwo = HANDOVER_TYPE_AREA_REASON_4_CWO_TO_OPE_ID;
  ho4CwoLoc = HANDOVER_TYPE_AREA_REASON_14_CWO_TO_OPE_ID;
  ho5loc = HANDOVER_TYPE_HO5_LOC_ID;
  isDr = false;
  showReceiverFooter = false;
  showReceiversFooter = false;
  handoverRelation: HandoverRelation | undefined;

  takenEmittersUsers: string | undefined;
  takenReceiversUsers: string | undefined;
  isEmitterSide = false;
  isReceiverSide = false;

  @ViewChild(HandoverDetailFooterEmitterComponent)
  private handoverDetailFooterEmitter!: HandoverDetailFooterEmitterComponent;
  @ViewChild(HandoverDetailFooterEmittersComponent)
  private handoverDetailFooterEmitters!: HandoverDetailFooterEmittersComponent;

  //variables para secciones
  SECCION_ESTADO = 0;
  SECCION_ARQUITECTURA = 1;
  SECCION_CEMENTACION = 2;
  SECCION_CABEZAL = 3;
  SECCION_ESPACIOS_ANULARES = 4;
  SECCION_COLUMNA_PRODUCCION = 5;
  SECCION_PUNZADO = 6;
  SECCION_PERFILES = 7;
  SECCION_BOCA_POZO = 8;
  SECCION_INTEGRIDAD = 9;
  SECCION_ABANDONO = 10;
  SECCION_ENTREGA_LOCACION = 11;
  SECCION_FRACTURA = 13;
  SECCION_TRAYECTORIA = 14;
  SECCION_ENSAYOS = 15;

  visibleSections = [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ];

  //holds the index of selected tab and by default set to 0
  selectedTabIndex = 0;

  dwfUrl = '';
  dwfAbandonUrl = '';

  constructor(
    private route: ActivatedRoute,
    private handoverService: HandoverService,
    private dialogService: DialogService,
    private notificationService: NotificationService,
    private router: Router,
    public dialog: MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private userService: UserService,
    private datepipe: DatePipe,
    private handoverReportService: HandoverReportService
  ) {
    this.matIconRegistry.addSvgIcon(
      'well-schematic-icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../assets/well-schematic-icon.svg'
      )
    );
    if (
      this.router.getCurrentNavigation()?.extras.state?.backTo == 'search-well'
    ) {
      this.toBack = '/initiateHandover';
    } else {
      this.toBack = '/';
    }
  }

  ngOnInit(): void {
    this.havePermissionSend =
      this.userService.hasPermission(PERMISSION_SEND_HO);
    this.getHandover();
  }

  haveReceivers(
    wellDistrictId: number | undefined,
    toAreaId: number,
    ugId: number
  ): void {
    this.handoverService
      .getValidReceiversCount(
        ugId,
        toAreaId,
        wellDistrictId ? wellDistrictId : null
      )
      .subscribe((r: HandoverValidReceiversCount) => {
        this.buttonSendHoDisabled = true;
        this.saveButtonToolTip = HANDOVER_SEND_OPERATIONS_PERMISSION_DENIED;
        if (r.avaiablesReceivers > 0) {
          this.buttonSendHoDisabled = false;
          this.saveButtonToolTip = '';
        }
      });
  }

  getHandover(): void {
    // TODO find a way to obtain route param without getting a possible null value
    const handoverId = parseInt(this.route.snapshot.paramMap.get('id') || '0');
    this.handoverService.getHandover(handoverId).subscribe((handover) => {
      this.handover = handover;
      this.displayFooter =
        handover.handoverStatusId != undefined &&
        HANDOVER_STATUSES_DISPLAY_FOOTER.includes(handover.handoverStatusId);

      this.isEngineerUser = this.userService.hasPermission(
        PERMISSION_ENGINEERING_COMPLETION
      );
      this.readOnlyContent = this.handoverService.validateHOViewOnlyState(
        this.handover.handoverStatusId,
        this.handover.handoverTypeId!,
        this.isEngineerUser,
        this.userService.getUserProperties().userId,
        this.handover.emmitterId,
        this.handover.editors,
        this.handover.sent,
        this.handover.sentEngineering
      );

      this.dwfUrl = `https://panamericanenergy.sharepoint.com/sites/DWF/SitePages/Documentos-de-Pozo.aspx?UWI=${this.handover.wellUwi}`;
      this.dwfAbandonUrl = `https://panamericanenergy.sharepoint.com/sites/DWF/SitePages/Documentos-de-Pozo.aspx?UWI=${this.handover.wellUwi}&CapituloId=10`;

      this.whatAmI = this.handover.editors?.includes(
        this.userService.getUserProperties().userId!
      )
        ? HANDOVER_EMITTER
        : this.userService.getUserProperties().userId ==
            this.handover.receiverId ||
          this.userService.getUserProperties().userId ==
            this.handover.receivingEngineerUserId
        ? HANDOVER_RECEIVER
        : '';
      this.iAmEmitter = this.whatAmI == HANDOVER_EMITTER;
      this.iAmReceiver = this.whatAmI == HANDOVER_RECEIVER;
      this.isHo3 = this.handover?.handoverTypeId == HANDOVER_TYPE_HO3_ID;
      this.isHo5 = this.handover?.handoverTypeId == HANDOVER_TYPE_HO5_ID;
      this.isAcceptedHo =
        this.handover?.handoverStatusId == HANDOVER_STATUS_ACCEPTED;

      this.isDr = [
        HANDOVER_TYPE_HO2_ID,
        HANDOVER_TYPE_HO4_ID,
        HANDOVER_TYPE_HO5_ID,
        HANDOVER_TYPE_HOEC_ID,
      ].includes(this.handover!.handoverTypeId!);

      this.displayFooterEmitter =
        handover.handoverStatusId == HANDOVER_STATUS_REJECTED &&
        this.iAmEmitter;

      this.displayFooterReceiver =
        this.iAmReceiver &&
        ((handover.handoverStatusId == HANDOVER_STATUS_TAKEN && !this.isDr) ||
          (this.isDr &&
            [HANDOVER_STATUS_TAKE_PENDING, HANDOVER_STATUS_TAKEN].includes(
              handover.handoverStatusId
            ) &&
            ((this.isEngineerUser &&
              !handover.receivingEngineerUserAccepted &&
              !handover.receivingEngineerUserRejected) ||
              (!this.isEngineerUser &&
                !handover.receivingUserAccepted &&
                !handover.receivingUserRejected))));

      if (this.readOnlyContent && !this.displayFooterReceiver)
        this.getActualTakenUsers();

      this.displayFooterView =
        (!this.iAmEmitter &&
          !this.iAmReceiver &&
          this.handover.receiverId != null) ||
        handover.handoverStatusId == HANDOVER_STATUS_ACCEPTED ||
        (handover.handoverStatusId == HANDOVER_STATUS_TAKEN &&
          this.iAmEmitter) ||
        (handover.handoverStatusId == HANDOVER_STATUS_REJECTED &&
          this.iAmReceiver) ||
        (handover.handoverTypeId != HANDOVER_TYPE_HO3_ID &&
          !this.isDr &&
          handover.handoverStatusId == HANDOVER_STATUS_TAKE_PENDING) ||
        (handover.handoverTypeId == HANDOVER_TYPE_HO3_ID &&
          handover.handoverStatusId == HANDOVER_STATUS_TAKE_PENDING &&
          !this.iAmEmitter) ||
        (handover.handoverStatusId == HANDOVER_STATUS_REJECTED &&
          this.iAmEmitter &&
          handover.sent! &&
          handover.sendingUserId! ==
            this.userService.getUserProperties().userId!) ||
        (handover.sentEngineering! &&
          handover.sendingEngineerUserId ==
            this.userService.getUserProperties().userId!) ||
        (this.isDr &&
          [HANDOVER_STATUS_TAKE_PENDING, HANDOVER_STATUS_TAKEN].includes(
            handover.handoverStatusId
          ) &&
          ((this.isEngineerUser &&
            (handover.receivingEngineerUserAccepted! ||
              handover.receivingEngineerUserRejected!)) ||
            (!this.isEngineerUser &&
              (handover.receivingUserAccepted! ||
                handover.receivingUserRejected!))));

      const sections = handover.sectionsList?.split(',');
      for (let index = 0; index < sections!.length; index++) {
        const element = sections![index];
        this.visibleSections[Number(element) - 1] = true;
      }

      this.havePermissionCancel =
        (this.userService.hasPermission(PERMISSION_CANCEL_HO) &&
          this.handover.handoverStatusId == HANDOVER_STATUS_CREATED) ||
        (this.userService.hasPermission(PERMISSION_CANCEL_REJECTED_HO) &&
          this.handover.handoverStatusId == HANDOVER_STATUS_REJECTED);

      this.hoActive =
        this.handover.handoverStatusId != HANDOVER_STATUS_ACCEPTED &&
        this.handover.handoverStatusId != HANDOVER_STATUS_CANCELED;

      this.iAmTheSenderUser =
        this.userService.getUserProperties().userId ==
        this.handover.sendingUserId;
      // validate if handover destination is OPE
      if (this.handover.toAreaId === OPERATIONAL_AREA_OPERATIONS_ID) {
        this.haveReceivers(
          this.handover.wellDistrictId,
          this.handover.toAreaId,
          this.handover.wellManagementUnitId
        );
      }
      this.hasSectionsComments = handover.hasSectionsComments;

      this.readOnlyContentHoec =
        this.readOnlyContent ||
        handover.handoverTypeId == HANDOVER_TYPE_HOEC_ID;

      this.readOnlyContentHoecHoac =
        this.readOnlyContent ||
        handover.handoverTypeId == HANDOVER_TYPE_HOEC_ID ||
        handover.handoverTypeId == HANDOVER_TYPE_HOAC_ID;

      this.reasonName =
        handover.handoverTypeId == HANDOVER_TYPE_HOAC_ID
          ? HANDOVER_REASON_NAME_HOAC
          : handover.reasonName;

      this.showReceiverFooter =
        (handover.handoverTypeId != this.ho3 && !this.isDr) ||
        (this.isDr &&
          !handover!.haveEngineeringObservations &&
          !handover!.haveOperationsObservations);

      this.showReceiversFooter =
        handover.handoverTypeId == this.ho3 ||
        (this.isDr &&
          (handover!.haveEngineeringObservations! ||
            handover!.haveOperationsObservations!));
      this.getHandoverRelation();
    });
  }

  getActualTakenUsers(): void {
    if (this.handover) {
      let OperationUserAssigned = false;
      if (
        this.handover.handoverStatusId == HANDOVER_STATUS_CREATED ||
        this.handover.handoverStatusId == HANDOVER_STATUS_REJECTED ||
        (this.handover.handoverStatusId == HANDOVER_STATUS_TAKE_PENDING &&
          !this.handover.firstSendDate)
      ) {
        this.takenEmittersUsers = 'Handover sin usuario asignado';
        //Si lo tiene asignado y todavía no lo envio Operaciones
        if (this.handover.sendingUser && !this.handover.sent) {
          this.takenEmittersUsers = this.handover.sendingUser;
          OperationUserAssigned = true;
        }

        //Si lo tiene asignado y todavía no lo envio Ingeniería
        if (
          this.handover.sendingEngineerUser &&
          !this.handover.sentEngineering
        ) {
          if (OperationUserAssigned)
            this.takenEmittersUsers +=
              ' y ' + this.handover.sendingEngineerUser;
          else this.takenEmittersUsers = this.handover.sendingEngineerUser;
        }

        this.isEmitterSide = true;
      }

      if (
        this.handover.handoverStatusId == HANDOVER_STATUS_TAKEN ||
        (this.handover.handoverStatusId == HANDOVER_STATUS_TAKE_PENDING &&
          this.handover.firstSendDate)
      ) {
        this.takenReceiversUsers = 'Handover sin usuario asignado';

        //Si lo tiene asignado y todavía no lo envio Operaciones
        if (
          this.handover.receivingUser &&
          !this.handover.receivingUserRejected &&
          !this.handover.receivingUserAccepted
        ) {
          this.takenReceiversUsers = this.handover.receivingUser;
          OperationUserAssigned = true;
        }

        //Si lo tiene asignado y todavía no lo envio Ingeniería
        if (
          this.handover.receivingEngineerUser &&
          !this.handover.receivingEngineerUserRejected &&
          !this.handover.receivingEngineerUserAccepted
        ) {
          if (OperationUserAssigned)
            this.takenReceiversUsers +=
              ' y ' + this.handover.receivingEngineerUser;
          else this.takenReceiversUsers = this.handover.receivingEngineerUser;
        }

        this.isReceiverSide = true;
      }
    }
  }

  getHandoverRelation(): void {
    if (this.handover) {
      if (
        this.handover.handoverId &&
        (this.handover.handoverTypeId == HANDOVER_TYPE_HO2_ID ||
          this.handover.handoverTypeId == HANDOVER_TYPE_HO1_ID ||
          this.handover.handoverTypeId == HANDOVER_TYPE_HOG_ID ||
          this.handover.handoverTypeAreaReasonId == this.ho4Cwo ||
          this.handover.handoverTypeId == this.ho5 ||
          this.handover.handoverTypeId == HANDOVER_TYPE_HO1_LOC_ID ||
          this.handover.handoverTypeId == HANDOVER_TYPE_HO2_LOC_ID ||
          this.handover.handoverTypeId == HANDOVER_TYPE_HOG_LOC_ID ||
          this.handover.handoverTypeAreaReasonId == this.ho4CwoLoc ||
          this.handover.handoverTypeId == this.ho5loc)
      ) {
        this.handoverService
          .getHandoverRelation(this.handover!.handoverId!)
          .subscribe((handoversRelation) => {
            this.handoverRelation = handoversRelation;
          });
      }
    }
  }

  openDatosGenerales(): void {
    if (this.displaySectionCommentComponent || this.displaySchematicComponent) {
      this.displaySectionCommentComponent = false;
      this.displaySchematicComponent = false;
    } else {
      this.drawerIsOpened = !this.drawerIsOpened;
    }
    this.wellDataIsOpen = !this.wellDataIsOpen;
  }

  validateAndSendHandover(): void {
    this.isLoading = true;
    this.buttonSendPushed = true;
    if (this.currentSectionHasPendingChanges) {
      this.dialogService
        .openConfirmDialog(
          'Salir de Handover',
          'Recuerde que si no guardó los cambios realizados, los mismos se perderán. ¿Está seguro que desea continuar?',
          'Sí, continuar',
          'No'
        )
        .afterClosed()
        .subscribe((res) => {
          if (res) {
            this.validateSectionsCompleted();
          } else {
            this.isLoading = false;
            this.buttonSendPushed = false;
          }
        });
    } else {
      this.validateSectionsCompleted();
    }
  }

  validateSectionsCompleted(): void {
    if (!this.handover?.handoverId) {
      return;
    }
    this.isValidated = false;
    this.handoverService
      .getSectionsCompletion(
        this.handover.handoverId,
        this.handover.wellId,
        this.handover.handoverTypeId!
      )
      .subscribe(async (completion) => {
        this.isLoading = false;
        if (true == completion.completed) {
          await this.validateOwRules();
          if (this.owRulesValidation) {
            this.sendHandover();
          }
        } else {
          this.markUncompletedSections(completion);
        }
        this.isValidated = true;
        this.buttonSendPushed = false;
      });
  }

  markUncompletedSections(completion: SectionsCompletion): void {
    this.notificationService.notify(
      `Hay campos oligatorios sin completar.`,
      HoSendMessages.ERROR_NOTIFICATION
    );
    this.sectionsCompletion = completion;
  }

  validateOwRules(): Promise<any> {
    const valType = this.buildOwValidationType(
      this.handover.handoverTypeId,
      this.handover.fromAreaId
    );
    if (valType != '') {
      this.isLoading = true;
      return new Promise((resolve, reject) => {
        this.handoverService
          .owValidation(this.handover.wellUwi, valType)
          .subscribe((handoverOwValidation) => {
            if (handoverOwValidation.validationResult === false) {
              this.owRulesValidation = false;
              let message;
              if (handoverOwValidation.rejectionMessage) {
                message = handoverOwValidation.rejectionMessage;
              } else {
                message =
                  'Ocurrió un problema al intentar validar las reglas envío de OpenWells, por favor contacte al administrador';
              }
              this.notificationService.notify(
                message,
                HoSendMessages.ERROR_NOTIFICATION
              );
            } else {
              this.owRulesValidation = true;
            }
            this.isLoading = false;
            resolve(this.owRulesValidation);
          });
      });
    } else {
      // Validations not included as a business rule, it is assumed to be true.
      return new Promise((resolve, reject) => {
        this.owRulesValidation = true;
        resolve(this.owRulesValidation);
      });
    }
  }

  buildOwValidationType(
    handoverTypeId: number | undefined,
    destinationGroupId: number | undefined
  ): string {
    let valType = '';
    switch (handoverTypeId) {
      case HANDOVER_TYPE_HO1_ID || HANDOVER_TYPE_HO1_LOC_ID: // HO1
        valType = HANDOVER_SEND_VALIDATION_TYPE_HO1;
        break;
      case HANDOVER_TYPE_HO2_ID || HANDOVER_TYPE_HO2_LOC_ID: // HO2
        valType = HANDOVER_SEND_VALIDATION_TYPE_HO2;
        break;
      case HANDOVER_TYPE_HO4_ID || HANDOVER_TYPE_HO4_LOC_ID: // H04
        if (destinationGroupId === OPERATIONAL_AREA_PULLING_ID) {
          valType = HANDOVER_SEND_VALIDATION_TYPE_HO4_PULLING;
        } else if (destinationGroupId === OPERATIONAL_AREA_COMPLETION_ID) {
          valType = HANDOVER_SEND_VALIDATION_TYPE_HO4_WORKOVER;
        }
        break;
      case HANDOVER_TYPE_HO5_ID || HANDOVER_TYPE_HO5_LOC_ID: // HO5
        valType = HANDOVER_SEND_VALIDATION_TYPE_HO5;
        break;
      case HANDOVER_TYPE_HOG_ID || HANDOVER_TYPE_HOG_LOC_ID: // HOG
        valType = HANDOVER_SEND_VALIDATION_TYPE_HOG;
        break;
      default:
        valType = '';
        break;
    }
    return valType;
  }

  sendHandover(): void {
    this.dialogService
      .openConfirmDialog(
        'Enviar Handover',
        `¿Estás seguro que querés <b>enviar el Handover</b> del <b>Pozo ${
          this.handover.wellName
        }</b> de <b>${this.handover.fromAreaName} A ${
          this.handover.toAreaName
        }${this.handover.reasonName ? ' ' + this.handover.reasonName : ''}</b>?`
      )
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.isLoading = true;
          let send = true;
          this.buttonSendHoDisabled = true;
          const isDr = [
            HANDOVER_TYPE_HO2_ID,
            HANDOVER_TYPE_HO4_ID,
            HANDOVER_TYPE_HO5_ID,
            HANDOVER_TYPE_HOEC_ID,
          ].includes(this.handover!.handoverTypeId!);
          if (
            this.handoverDetailFooterEmitter ||
            this.handoverDetailFooterEmitters
          ) {
            const datetime = this.datepipe.transform(
              Date.now(),
              'yyyy-MM-dd HH:mm:ss'
            );
            if (!isDr) {
              this.handoverDetailFooterEmitter.observations.forEach(
                (o) => (o.emitterObservationDatetime = datetime ?? '')
              );
              send =
                this.handoverDetailFooterEmitter.observations.filter(
                  (o) =>
                    o.showEmitterObservation &&
                    ((!o.emitterObservationSolved &&
                      !o.emitterObservationNotSolved) ||
                      (o.emitterObservationNotSolved &&
                        o.emitterDescriptionObservationNotSolved.trim() == ''))
                ).length == 0;
            } else {
              this.handoverDetailFooterEmitters.observations.forEach(
                (o) => (o.emitterObservationDatetime = datetime ?? '')
              );
              this.handoverDetailFooterEmitters.engineeringOservations.forEach(
                (o) => (o.emitterObservationDatetime = datetime ?? '')
              );
              send =
                this.handoverDetailFooterEmitters.observations.filter(
                  (o) =>
                    o.showEmitterObservation &&
                    ((!o.emitterObservationSolved &&
                      !o.emitterObservationNotSolved) ||
                      (o.emitterObservationNotSolved &&
                        o.emitterDescriptionObservationNotSolved.trim() == ''))
                ).length == 0 &&
                this.handoverDetailFooterEmitters.engineeringOservations.filter(
                  (o) =>
                    o.showEmitterObservation &&
                    ((!o.emitterObservationSolved &&
                      !o.emitterObservationNotSolved) ||
                      (o.emitterObservationNotSolved &&
                        o.emitterDescriptionObservationNotSolved.trim() == ''))
                ).length == 0;
            }
          }
          if (!send) {
            this.isLoading = false;
            this.buttonSendHoDisabled = false;
            this.notificationService.notify(
              `Hay observaciones pendientes de resolución.`,
              HoSendMessages.ERROR_NOTIFICATION
            );
          } else {
            let observations;
            if (!isDr) {
              observations = this.handoverDetailFooterEmitter
                ? this.handoverDetailFooterEmitter.observations.filter(
                    (o) => o.showEmitterObservation
                  )
                : [];
            } else {
              observations = this.handoverDetailFooterEmitters
                ? this.handoverDetailFooterEmitters.observations
                    .concat(
                      this.handoverDetailFooterEmitters.engineeringOservations
                    )
                    .filter((o) => o.showEmitterObservation)
                : [];
            }
            this.handoverService
              .sendHandover(
                this.handover.handoverId ? this.handover.handoverId : 0,
                this.handover.handoverTypeId!,
                this.handover.handoverStatusId!,
                observations
              )
              .subscribe((handoverOperationResult) => {
                if (handoverOperationResult) {
                  this.currentSectionHasPendingChanges = false;
                  this.footerHasPendingChanges = false;
                  let message = `${HoSendMessages.SEND_HO_SUCCESS_INI} ${handoverOperationResult.handover.handoverId} ${HoSendMessages.SEND_HO_SUCCESS_END}`;
                  if (
                    !handoverOperationResult.notificationSent &&
                    !handoverOperationResult.ho3skipNotification
                  ) {
                    message += `\nLa acción fue realizada, pero no se ha podido notificar vía mail a ${this.handover.toAreaName}.\nPor favor, notifique a ${PAE_SUPPORT_EMAIL} de este inconveniente.`;
                  }
                  this.notificationService.notify(
                    message,
                    HoSendMessages.SUCCESS_NOTIFICATION
                  );
                  setTimeout(
                    () => {
                      this.isLoading = false;
                      this.goToHome();
                    },
                    !handoverOperationResult.notificationSent
                      ? SUCCESS_WARNING_TIME_MESSAGE
                      : SUCCESS_TIME_MESSAGE
                  );
                } else {
                  this.isLoading = false;
                  this.buttonSendHoDisabled = false;
                  this.notificationService.notify(
                    `${HoSendMessages.SEND_HO_ERROR_INI} \n${HoSendMessages.SEND_HO_ERROR_END}`,
                    HoSendMessages.ERROR_NOTIFICATION
                  );
                }
              });
          }
        }
      });
  }

  goToHome(): void {
    this.router.navigateByUrl(`/`);
  }

  toggleSchematicDrawer(): void {
    if (this.displaySectionCommentComponent || this.wellDataIsOpen) {
      this.displaySectionCommentComponent = false;
      this.wellDataIsOpen = false;
    } else {
      this.drawerIsOpened = !this.drawerIsOpened;
    }
    this.displaySchematicComponent = !this.displaySchematicComponent;
  }

  toggleCommentsDrawer(): void {
    if (this.displaySchematicComponent || this.wellDataIsOpen) {
      this.displaySchematicComponent = false;
      this.wellDataIsOpen = false;
    } else {
      this.drawerIsOpened = !this.drawerIsOpened;
    }
    this.displaySectionCommentComponent = !this.displaySectionCommentComponent;
  }

  closeDrawer(): void {
    this.drawerIsOpened = false;
    this.wellDataIsOpen = false;
    this.displaySchematicComponent = false;
    this.displaySectionCommentComponent = false;
  }

  async getHoAbandonReport(): Promise<void> {
    if (this.handover.handoverId) {
      this.isLoading = true;
      this.handoverReportService
        .getHoAbandonReportData(this.handover.handoverId, this.handover.wellUwi)
        .subscribe((response: HttpResponse<Blob>) => {
          this.downLoadFile(response);
          this.isLoading = false;
        });
    }
  }

  private downLoadFile(response: HttpResponse<Blob>) {
    const fileName =
      response.headers.get('content-disposition')?.split('filename=')[1] ||
      `informe_de_abandono_${this.handover.wellName}.docx`;
    if (this.handover.wellName)
      fileName.replace('default', this.handover.wellName);
    if (response && response.body) {
      const blob = new Blob([response.body], {
        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      });
      const f = document.createElement('a');
      f.href = window.URL.createObjectURL(blob);
      f.download = fileName;
      f.click();
    } else {
      this.notificationService.notify(
        'Ocurrió un error al intentar descargar el reporte.',
        false
      );
    }
  }

  goToBack(): void {
    this.router.navigateByUrl(`${this.toBack}`);
  }

  cancelHandover(): void {
    this.dialogService
      .openConfirmDialog(
        'Cancelar Handover',
        `Esta seguro que querés <b>cancelar</b> el Handover del <b>Pozo ${this.handover.wellName}</b>`,
        'Sí, cancelar',
        'No'
      )
      .afterClosed()
      .subscribe((confirmCancel) => {
        if (confirmCancel && this.handover.handoverId) {
          this.isLoading = true;
          this.handoverService
            .cancelHandover(this.handover.handoverId)
            .subscribe((canceledHandover) => {
              if (
                HANDOVER_STATUS_CANCELED == canceledHandover.handoverStatusId
              ) {
                this.notificationService.notify(
                  `El Handover del Pozo ${this.handover.wellName} ha sido cancelado con éxito`,
                  HoSendMessages.SUCCESS_NOTIFICATION
                );
                if (
                  (this.ho2 == this.handover.handoverTypeId ||
                    this.ho1 == this.handover.handoverTypeId ||
                    this.ho2loc == this.handover.handoverTypeId ||
                    this.ho1loc == this.handover.handoverTypeId ||
                    this.hog == this.handover.handoverTypeId ||
                    this.hogloc == this.handover.handoverTypeId ||
                    this.ho4Cwo == this.handover.handoverTypeAreaReasonId ||
                    this.ho4CwoLoc == this.handover.handoverTypeAreaReasonId ||
                    this.ho5 == this.handover.handoverTypeId ||
                    this.ho5loc == this.handover.handoverTypeId) &&
                  this.handover.handoverId
                ) {
                  this.handoverService
                    .deleteHandoverRelation(this.handover.handoverId)
                    .subscribe();
                }
                setTimeout(() => {
                  this.isLoading = false;
                  this.goToHome();
                }, SUCCESS_TIME_MESSAGE);
              } else {
                this.isLoading = false;
              }
            });
        }
      });
  }

  sectionTouched(sectionName: string): void {
    if (undefined !== this.sectionsCompletion) {
      if (['status', 'notifications'].includes(sectionName)) {
        // hack to unmark status and notifications
        this.sectionsCompletion.sections['status'] = true;
        this.sectionsCompletion.sections['notifications'] = true;
      } else {
        this.sectionsCompletion.sections[sectionName] = true;
      }
    }
  }

  changeStatusLoading(loading: boolean): void {
    this.isLoading = loading;
  }

  /**
   * Displays a confirmation dialog to let the user know
   * he is gonna lose changes if navigation to other route of the app occurs.
   * @returns wether the user has given permission to navigate or not.
   */
  notifiyNavigationAwayFromMe(
    dialogTitle = 'Salir de Handover',
    dialogText = 'Recuerde que si no guardó los cambios realizados, los mismos se perderán. ¿Está seguro que desea continuar?'
  ): Observable<boolean> {
    return this.dialogService
      .openConfirmDialog(dialogTitle, dialogText, 'Sí, continuar', 'No')
      .afterClosed();
  }

  /**
   * Listener for the window:onbeforeunload event. Prompts defaut browser
   * confirm dialog if there is any data to be lost. Cannot make use of
   * component's dialog service, see @external https://stackoverflow.com/a/42207299
   * to know the reasons for that limitation.
   * @param $event
   */
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnloadHandler($event: any): string | void {
    if (this.currentSectionHasPendingChanges) {
      $event.preventDefault();
      return ($event.returnValue =
        'Recuerde que si no guardó los cambios realizados, los mismos se perderán. ¿Está seguro que desea continuar?');
    }

    if (this.footerHasPendingChanges) {
      $event.preventDefault();
      return ($event.returnValue =
        'Recuerde que si no guardó los cambios realizados, los mismos se perderán. ¿Está seguro que desea continuar?');
    }
  }

  /**
   * Handles onTabGroupClick event and, if needed, requests
   * user confirmation before switching to the clicked tab.
   */
  onTabGroupClick(event: any): void {
    const offsetParent = event.target.offsetParent;
    let tabAriaIdentifier;
    if (offsetParent) {
      tabAriaIdentifier = offsetParent.attributes.getNamedItem('aria-posinset');
      if (!tabAriaIdentifier) {
        return;
      }
    } else {
      return;
    }

    const clickedTab = Number(tabAriaIdentifier.value) - 1;
    if (!(this.selectedTabIndex === clickedTab)) {
      if (!this.currentSectionHasPendingChanges) {
        this.selectedTabIndex = clickedTab;
      } else {
        this.notifiyNavigationAwayFromMe('Cambiar de Sección').subscribe(
          (response) => {
            if (response) {
              this.selectedTabIndex = clickedTab;
              this.currentSectionHasPendingChanges = false;
            }
          }
        );
      }
    }
  }

  showRedPointSectionsComments(show: boolean): void {
    this.hasSectionsComments = show;
  }

  onSectionHasPendingChanges(hasPendingChanges: boolean): void {
    this.currentSectionHasPendingChanges = hasPendingChanges;
  }

  onFooterHasPendingChanges(hasPendingChanges: boolean): void {
    this.footerHasPendingChanges = hasPendingChanges;
  }

  displayDeliveryLocation(): boolean {
    return (
      this.handover.handoverTypeId == this.ho2 ||
      (this.handover.handoverTypeId == this.ho3 &&
        (this.handover.handoverTypeAreaReasonId ==
          HANDOVER_TYPE_AREA_REASON_3_OPE_TO_CWO_ID ||
          this.handover.handoverTypeAreaReasonId ==
            HANDOVER_TYPE_AREA_REASON_3_OPE_TO_PUL_ID)) ||
      this.handover.handoverTypeId == this.ho4 ||
      this.handover.handoverTypeId == this.ho5 ||
      this.handover.handoverTypeId == this.hloc0 ||
      this.handover.handoverTypeId == this.hloc ||
      this.handover.handoverTypeId == this.ho1 ||
      this.handover.handoverTypeId == this.hog ||
      this.handover.handoverTypeId == this.hoec ||
      this.handover.handoverTypeId == this.hoac ||
      this.handover.handoverTypeId == this.ho2loc ||
      this.handover.handoverTypeId == this.ho1loc ||
      this.handover.handoverTypeId == this.hogloc ||
      this.handover.handoverTypeAreaReasonId == this.ho4CwoLoc ||
      this.handover.handoverTypeId == this.ho5loc
    );
  }

  linkDwfAbandon() {
    window.open(this.dwfAbandonUrl, '_blank');
  }

  /**
   * Determina si se muestra la sección "Resumen Ejecutivo".
   * Primer incremento (cascarón): visible sólo para handovers tipo HOG y HO1
   * (incluye sus variantes de locación). Gating por tipo de handover ya que
   * la sección aún no forma parte del sectionsList del backend.
   * Además, se oculta en producción vía `environment.executiveResumeEnabled`
   * hasta que la sección esté lista para liberar.
   * TODO(backend): incorporar la sección al sectionsList y usar visibleSections.
   */
  get showExecutiveResume(): boolean {
    if (!environment.executiveResumeEnabled) {
      return false;
    }
    const typeId = this.handover?.handoverTypeId;
    return (
      typeId === this.ho1 ||
      typeId === this.hog ||
      typeId === this.ho1loc ||
      typeId === this.hogloc
    );
  }
}
